<div class="container-fluid">
<div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b>&nbsp;Monitor Sessions</b></h5>
    </div>
  </div>
  <hr>

  <ul class="nav nav-tabs">
    <li  data-toggle="tab" class="tablinks active" (click)="openContent($event, 'ActiveSession')">Active Sessions</li>
    <li  data-toggle="tab" class="tablinks" (click)="openContent($event, 'History')">History</li>
  </ul>
  
    <div class="tab-content">
    <div id="ActiveSession" style="display: block" class="tabcontent">
      <fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;">
        <div class="row" style="margin:15px auto!important;padding-left:100px;">
          <div class="col-10 resizer" style="width:350px; padding:0px">
            <input type="text" style="width:280px!important;height:35px"
                   class="form-control form-control-lg pull-right" 
                   [(ngModel)]="activePcName"
                   placeholder="Filter by PC name..."
                   title="Enter the PC name to filter by..."
                   >
          </div>
          <div class="col-2 btn-show" style="width:80px !important; margin:0px!important;padding-top:0px!important;">
            <span (click)="onSearchReset()" title="Reset filter..." class="btn btn-success btn-sm pull-right"><i class="fa fa-undo" aria-hidden="true"></i></span>
            <span title="Apply filters..." (click)="onSearchActiveSessions()" class="btn btn-primary btn-sm pull-right" style="margin-right: 6px !important;"><i class="fa fa-filter" aria-hidden="true"></i></span>
          </div>
        </div>
      </fieldset>
      <br>

        <table class="table table-sm table-striped" style="width:100%;">
            <thead class="thead-inverse">
              <tr class="hd-clpse">
                
                <th style="width:10%;">
                  Session Id
                  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagSI == 2),'fa-sort-desc sort-d': (flags.flagSI == 3), 'fa-sort':(flags.flagSI == 1) }" (click)="onSort(1)"></i>
                </th>
                <th style="width:20%;">
                  PC Name
                  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPN == 2),'fa-sort-desc sort-d': (flags.flagPN == 3), 'fa-sort':(flags.flagPN == 1) }" (click)="onSort(2)"></i>
                </th>
                <th>
                  PC IP Address
                  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPA == 2),'fa-sort-desc sort-d': (flags.flagPA == 3), 'fa-sort':(flags.flagPA == 1) }" (click)="onSort(3)"></i>
                </th>
                <th style="width:20%;">
                 Connection Id
                  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagST == 2),'fa-sort-desc sort-d': (flags.flagST == 3), 'fa-sort':(flags.flagST == 1) }" (click)="onSort(4)"></i>
                </th>
                <th style="width:15%;">
                  Session Start
                  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagSS == 2),'fa-sort-desc sort-d': (flags.flagSS == 3), 'fa-sort':(flags.flagSS == 1) }" (click)="onSort(6)"></i>
                </th>
                <th style="width:15%;">
                  Session Last Seen
                  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagSE == 2),'fa-sort-desc sort-d': (flags.flagSE == 3), 'fa-sort':(flags.flagSE == 1) }" (click)="onSort(5)"></i>
                </th>
                <th>
                  Terminate Session
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="tbl-row" *ngFor="let item of activesessionlist| async | orderBy: criteria : direction | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}">
                
                <td class="longtext bfr-end-col" title="{{item.sessionId}}">{{item.sessionId}}</td>
                <td class="bfr-end-col">{{item.pcName}}</td>
                <td class="bfr-end-col">{{item.pcIpAddress}}</td>
                <td class="bfr-end-col">{{item.connectionId}}</td>
                <td class="bfr-end-col">{{item.sessionStartTime?.toLocaleString() | date:'dd/MM/yyyy h:mm:ss a'}}</td>
                <td class="bfr-end-col">{{item.sessionEndTime?.toLocaleString() | date:'dd/MM/yyyy h:mm:ss a'}}</td>
                <td class="bfr-end-col"><span (click)="TerminateSession(item)" title="Terminate this session" class="btn btn-danger btn-sm">x</span></td>
                <!-- <td class="btn-show end-col" style="width:10%!important;">
  
                  <span title="Terminate Session" tyle="margin: 0%" class="btn btn-success btn-sm pull-center">
                    <img src="/assets/permit-viewer2.png" class="permit-view" />
                  </span>
                </td> -->
              </tr>
            </tbody>
            <tfoot style="padding:0px;margin:0px;">
              <tr *ngIf="isListEmpty">
                <td colspan="4" class="rm-brd">
                  <span class="text-info text-small">No active sessions found.</span>
                </td>
              </tr>
            </tfoot>
        </table>
    </div>
    <div id="History" class="tabcontent" style="margin:4px auto!important;padding:0px">
      <div class="col-12" style="margin:0px!important;padding:0px!important;">
        <fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;">
            <div class="row" style="margin:15px auto!important;padding-left:100px;">
              <div class="col-10 resizer" style="width:350px; padding:0px">
                <input type="text" style="width:280px!important;height:35px"
                       class="form-control form-control-lg pull-right" 
                       [(ngModel)]="pcName"
                       placeholder="Filter by PC name..."
                       title="Enter the PC name to filter by..."
                      >
              </div>
              <div class="col-2 btn-show" style="width:80px !important; margin:0px!important;padding-top:0px!important;">
                <span (click)="onReset()" title="Reset filter..." class="btn btn-success btn-sm pull-right"><i class="fa fa-undo" aria-hidden="true"></i></span>
                <span title="Apply filters..." (click)="onSearch()" class="btn btn-primary btn-sm pull-right" style="margin-right: 6px !important;"><i class="fa fa-filter" aria-hidden="true"></i></span>
              </div>
            </div>
          </fieldset>
          <br>

        <table class="table table-sm table-striped" style="width:100%;">
          <thead class="thead-inverse">
            <tr class="hd-clpse">
              
              <th style="width:20%;">
                Session Id
                <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagSI == 2),'fa-sort-desc sort-d': (flags.flagSI == 3), 'fa-sort':(flags.flagSI == 1) }" (click)="onSort(1)"></i>
              </th>
              <th style="width:20%;">
                PC Name
                <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPN == 2),'fa-sort-desc sort-d': (flags.flagPN == 3), 'fa-sort':(flags.flagPN == 1) }" (click)="onSort(2)"></i>
              </th>
              <th>
                PC IP Address
                <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPA == 2),'fa-sort-desc sort-d': (flags.flagPA == 3), 'fa-sort':(flags.flagPA == 1) }" (click)="onSort(3)"></i>
              </th>
              <!-- <th style="width:20%;">
                Status
                <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagST == 2),'fa-sort-desc sort-d': (flags.flagST == 3), 'fa-sort':(flags.flagST == 1) }" (click)="onSort(4)"></i>
              </th> -->
              <th style="width:15%;">
                Session Start
                <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagSS == 2),'fa-sort-desc sort-d': (flags.flagSS == 3), 'fa-sort':(flags.flagSS == 1) }" (click)="onSort(6)"></i>
              </th>
              <th style="width:15%;">
                Session End
                <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagSE == 2),'fa-sort-desc sort-d': (flags.flagSE == 3), 'fa-sort':(flags.flagSE == 1) }" (click)="onSort(5)"></i>
              </th>
              <!-- <th>
                Terminate Session
              </th> -->
            </tr>
          </thead>
          <tbody>
            <tr class="tbl-row" *ngFor="let item of sessions | orderBy: criteria : direction | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}">
              
              <td class="longtext bfr-end-col" title="{{item.SessionId}}">{{item.SessionId}}</td>
              <td class="bfr-end-col">{{item.PcName}}</td>
              <td class="bfr-end-col">{{item.PcIpAddress}}</td>
              <!-- <td class="bfr-end-col">{{item.StatusId}}</td> -->
              <td class="bfr-end-col">{{item.SessionStartTime?.toLocaleString() | date:'dd/MM/yyyy h:mm:ss a'}}</td>
              <td class="bfr-end-col">{{item.SessionEndTime?.toLocaleString() | date:'dd/MM/yyyy h:mm:ss a'}}</td>
              <!-- <td> <span (click)="TerminateSession(item.SessionId)" title="Terminate this session" class="btn btn-danger btn-sm">x</span></td> -->
              <!-- <td class="btn-show end-col" style="width:10%!important;">

                <span title="Terminate Session" tyle="margin: 0%" class="btn btn-success btn-sm pull-center">
                  <img src="/assets/permit-viewer2.png" class="permit-view" />
                </span>
              </td> -->
            </tr>
          </tbody>
          <tfoot style="padding:0px;margin:0px;">
             <tr *ngIf="count > 10" style="padding-left:0px;margin-left:0px;">
              <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
                <div class="row">
  
                  <div class="col-2">
                    <div class="input-group mb-3 rm-brd" style="width:135px!important;height:30px!important;">
                      <div class="input-group-prepend">
                        <label class="input-group-text form-control-sm show-h" for="show-id">Show:</label>
                      </div>
                      <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="pageSize" (change)="onChange()">
                        <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-8 text-center">
                    <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                  </div>
                </div>
              </td>
            </tr> 
            <tr *ngIf="isEmpty">
              <td colspan="4" class="rm-brd">
                <span class="text-info text-small">No sessions found.</span>
              </td>
            </tr>
          </tfoot>
          <br>
        </table>
      </div>
    </div>
</div>
  
</div>
  